import React from "react";
import "../ServicePage/service_com_2.css";

const SpecialityescriptionSection = () => {
  return (
    <section className="desc-section">
      <div className="desc-container">
        <h1>How We Will Rectify Your Exact Birth Time</h1>
        <p>
      We use a detailed astrological process that matches your life events, nature, and personality patterns with planetary timelines. This helps us identify the most accurate moment of your birth — your true cosmic time.

        </p>
        <p>We Will Ask You Questions Like:
</p>

<ul>
  <li>
Major life events (education, job, relationship, health changes, etc.)
</li>
<li>Your personality traits and habits (anger, calmness, lifestyle, etc.)
</li>
<li>Physical appearance and body type
</li>
<li>Key family events or milestones
</li>
<li>Any approximate birth time you’ve been told (morning, night, etc.)
</li>
  </ul>
        <p>
         Based on your answers, we analyze multiple planetary charts to find the most accurate birth time.
Once your time is finalized, we proceed with your complete Kundli Analysis.

        </p>
        {/* <p>
          Volutpat commodo orci sit viverra mauris nibh turpis nulla. Enim
          ultrices semper urna arcu nibh. Habitant tristique non bibendum ut
          vitae amet est. Iaculis ipsum tempus sociis vitae in. Finibus laoreet
          iaculis ut massa.
        </p>
        <p>
          Lectus ut neque quam turpis blandit ipsum vitae sit. Feugiat odio
          gravida feugiat tincidunt. Scelerisque non nisi arcu in molestie purus
          tempor. Viverra interdum ut enim sodales et convallis nunc.
        </p>
        <p>
          Lorem pretium feugiat tincidunt laoreet. Vitae volutpat augue libero a
          ullamcorper elit facilisi feugiat mauris. Rhoncus id ultricies orci
          diam ornare eu habitant.
        </p> */}
      </div>
    </section>
  );
};

export default SpecialityescriptionSection;
